var _path, _g, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_16",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 16,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5C12 15.3579 15.3579 12 19.5 12H20.5C24.6421 12 28 15.3579 28 19.5V19.5C28 23.6421 24.6421 27 20.5 27H19.5C15.3579 27 12 23.6421 12 19.5V19.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20C12 15.5817 15.5817 12 20 12V12C24.4183 12 28 15.5817 28 20V22.75C28 27.1683 24.4183 30.75 20 30.75V30.75C15.5817 30.75 12 27.1683 12 22.75V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5C12 15.3579 15.3579 12 19.5 12H20.5C24.6421 12 28 15.3579 28 19.5V19.5C28 23.6421 24.6421 27 20.5 27H19.5C15.3579 27 12 23.6421 12 19.5V19.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5C12 15.3579 15.3579 12 19.5 12H20.5C24.6421 12 28 15.3579 28 19.5V19.5C28 23.6421 24.6421 27 20.5 27H19.5C15.3579 27 12 23.6421 12 19.5V19.5Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_26_16",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6145 5.63542H33.7083V32.7292H6.6145V5.63542Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_26_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7187 19.1719C33.7187 11.6927 27.6562 5.625 20.1718 5.625C12.6926 5.625 6.63013 11.6927 6.63013 19.1719C6.63013 26.651 12.6926 32.7187 20.1718 32.7187C27.6562 32.7187 33.7187 26.651 33.7187 19.1719ZM19.2551 23.2969C19.1874 23.2344 19.1353 23.1615 19.0833 23.0833L13.9999 18C13.7551 17.7552 13.6301 17.4323 13.6301 17.1094C13.6301 16.7865 13.7551 16.4583 13.9999 16.2135C14.4947 15.7187 15.2968 15.7187 15.7916 16.2135L20.1718 20.5937L24.5312 16.2344C25.026 15.7396 25.8228 15.7396 26.3176 16.2344C26.8124 16.7292 26.8124 17.5313 26.3176 18.026L21.2603 23.0833C21.2083 23.1615 21.1562 23.2344 21.0885 23.2969C20.8333 23.5521 20.5051 23.6719 20.1718 23.6667C19.8385 23.6719 19.5103 23.5521 19.2551 23.2969Z",
    fill: "#E6C357"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/iconArrowDown.71b0a220.svg";
export { ForwardRef as ReactComponent };